<template>
  <section>
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword"></Header>
    <div class="container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="item.name" :name="item.id+''" v-for="(item,index) in categoryList" :key="index">
         <div class="help-cont layui-form">
          <ul class="clearfix clearlist kblist">
            <li v-for="(item_i,index_i) in child.data" :key="index_i">
              <a :href="'#/newschd?id='+item.id+'&detailid='+item_i.id">
                <div class="tit ellipsis">{{item_i.title}}</div>
                <div class="desc">{{item_i.description}}</div>
              </a>
            </li>
          </ul>
        </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
        <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
        <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane> -->
      </el-tabs>
      <!-- <div class="help-main" style="float: left">
        <div class="help-tit">{{parentname}}</div>
        <div class="help-cont layui-form">
          <ul class="clearfix clearlist kblist">
            <li v-for="(item,index) in list" :key="index">
              <a :href="'#/newschd?id='+item.id">
                <div class="tit ellipsis">{{item.title}}</div>
                <div class="desc">{{item.description}}</div>
              </a>
            </li>
          </ul>
        </div>
      </div>-->
    </div>
    <Footer :indexData="indexData"></Footer>
  </section>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";
export default {
  components: {
    Header,
    Footer
  },
  name: "Newslist",
  data() {
    return {
      activeName: "",
      keyword:"",
      child:[],
      indexData: {
        index_cartnum: 0,
        index_shop_self: {
          adlist: [{ url: "", src: "" }, { url: "", src: "" }]
        }
      },
      userInfo: {},

      categoryList:[{child:[]}],
    };
  },
  methods: {
    // 获取分类列表
    async getlist() {
      let categoryList = await this.$fetch("index/category", {
        body: { }
      });
      this.categoryList=categoryList;
     
      // categoryList.map(async(item,index)=>{
      //   let child=await this.$fetch("index/content", {
      //      body: { pid:item.id}
      //   })
      //   item['child']=child.data||[]
      //    console.log(item)
      // })
     
      // this.categoryList=categoryList;
       this.activeName=categoryList[0].id+'';
       this.getclassfyList(categoryList[0].id);
    },
    // 获取对应的列表
   async getclassfyList(pid){
       this.child=await this.$fetch("index/content", {
           body: { pid}
        })
    },
    handleClick(tab, event) {
       this.getclassfyList(tab.name);
    }
  },

  async mounted() {
    let that = this;
    this.guid = sessionStorage.guid;
     this.indexData = await this.$fetch("Index/indexdata");
    if (sessionStorage.user) {
      this.userInfo = JSON.parse(sessionStorage.user);
    }
    this.getlist();
  }
};
</script>


<style lang='scss' scoped>
.el-tabs--top{
  margin: 24px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/newslist.vue